import { GET_DASHBOARD_V2_PERFORMANCE, GET_DASHBOARD_V2_STATIONS } from 'actions/dashboardV2';

const initialState = {
  isPerformanceLoading: false,
  isStationsLoading: false,
  performance: null,
  stations: {
    top_revenue: [],
    top_utilization: [],
    worst_revenue: [],
    worst_utilization: [],
  },
};

const dashboardV2Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DASHBOARD_V2_PERFORMANCE.REQUEST:
      return { ...state, isPerformanceLoading: true };

    case GET_DASHBOARD_V2_STATIONS.REQUEST:
      return { ...state, isStationsLoading: true };

    case GET_DASHBOARD_V2_PERFORMANCE.SUCCESS:
      return { ...state, isPerformanceLoading: false, performance: payload };

    case GET_DASHBOARD_V2_STATIONS.SUCCESS:
      return {
        ...state,
        isStationsLoading: false,
        stations: { ...state.stations, [payload.key]: payload.data },
      };

    case GET_DASHBOARD_V2_PERFORMANCE.FAIL:
      return { ...state, isPerformanceLoading: false };

    case GET_DASHBOARD_V2_STATIONS.FAIL:
      return { ...state, isStationsLoading: false };

    default:
      return { ...state };
  }
};

export default dashboardV2Reducer;
